// extracted by mini-css-extract-plugin
module.exports = {"copy_btn":"InviteModal_copy_btn__kN6Re"};